module.exports = __webpack_public_path__ + "img/toumingmofakoudai.min.f0729945.png";